<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
// Import Bulma's core
//@import "~bulma/sass/utilities/_all";

// Set your colors
//$primary: #0B5FFF;
@import "./assets/custom-scss/custom-scss";


// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>



// WEBPACK FOOTER //
// src/App.vue